const RECEIPT_LOOKUP_ENDPOINT = process.env.RECEIPT_LOOKUP_ENDPOINT ?? "";

/**
 * Submits a public receipt-lookup search.
 *
 * The backend search endpoint is owned by AO-32782 and does not exist yet. When
 * the endpoint path is not configured, this resolves to a well-defined
 * "not available" result instead of calling a non-existent endpoint, so the page
 * ships UI-only. Real failures from a configured endpoint surface to the caller.
 */
class ReceiptLookupService {
  constructor(client) {
    this.apiClient = client;
  }

  /**
   * Assembles and submits the receipt-lookup request.
   *
   * @param {string} entityId The facility or facility-group id.
   * @param {object} payload The flat form payload (paymentDate, cardType, last4,
   *   amount, optional ticketId, optional licensePlate).
   * @returns {Promise<{ available: boolean, data?: object }>} The lookup result,
   *   or `{ available: false }` when the endpoint is not yet configured.
   */
  async submitReceiptLookup(entityId, payload) {
    const request = { ...payload, entityId };

    if (RECEIPT_LOOKUP_ENDPOINT === "") {
      return { available: false };
    }

    const response = await this.apiClient.post(
      RECEIPT_LOOKUP_ENDPOINT,
      request
    );
    return { available: true, data: response.data };
  }
}

export default ReceiptLookupService;
